import React from 'react';
import 'twin.macro';
import { Attachment } from '@teetsh/app/src/types/attachment';
import { AcceptOnly, useDropzone } from './useDropzone';
import Input, { inputRootStyle } from 'components/Form/Input2';
import tw from 'twin.macro';
import { ArrowPathIcon as Refresh } from '@heroicons/react/24/outline';

interface Props {
  onChange: (v: Attachment[]) => void;
  attachments?: Attachment[];
  uploadingAttachment?: boolean;
  handleError: ({ message }: { message: string }) => void;
  handleUploadAttachment: (payload: { file: File }) => Promise<any>;
  multiple?: boolean;
  acceptOnly?: AcceptOnly;
  className?: string;
  minimal?: boolean;
}

export function InputAttachment(props: Props) {
  const {
    attachments = [],
    uploadingAttachment = false,
    onChange,
    handleUploadAttachment,
    handleError,
    multiple,
    acceptOnly,
    minimal,
  } = props;

  const { getRootProps, getInputProps } = useDropzone({
    handleUploadAttachment,
    handleError,
    attachments,
    onChange,
    multiple,
    acceptOnly,
  });

  const { ref, ...rootProps } = getRootProps();
  return (
    <div {...rootProps} data-testid="attachment-area" ref={ref}>
      <Input
        rightElement={
          uploadingAttachment && (
            <Refresh
              tw="animate-spin pointer-events-none h-5 w-5"
              aria-hidden="true"
            />
          )
        }
        value=""
        data-testid="attachment-input"
        css={[minimal && tw`border-transparent hover:border-neutral-quiet`]}
      />
      <input
        css={[inputRootStyle({})]}
        {...(getInputProps() as any)}
        data-testid="attachment-input"
      />
    </div>
  );
}
